import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import postsQuery from './modules/postsQuery'
import singlePostQuery from './modules/singlePostQuery'
import video from './modules/video'
import authorQuery from './modules/authorQuery'
import actionsQueue from './modules/actionsQueue'
import tagsQuery from './modules/tagsQuery'
import likesQuery from './modules/likesQuery'
import notificationQuery from './modules/notificationQuery'
import profileQuery from './modules/profileQuery'
import shareQuery from './modules/shareConnection'
import systemStore from './modules/system'
import favQuery from './modules/favQuery'
import webView from './modules/webView'
import authStore from '@chi-x/chi-login/lib/store'
import visibility from './modules/visibility'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    postsQuery,
    singlePostQuery,
    notificationQuery,
    profileQuery,
    shareQuery,
    authorQuery,
    tagsQuery,
    likesQuery,
    favQuery,
    webView,
    video,
    actionsQueue,
    visibility,
    auth: { ...authStore },
    system: { ...systemStore }
  },
  // plugins: [createPersistedState()],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js